import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import usePlans from "../../hooks/usePlans";

const PlansContext = createContext();

export const usePlansContext = () => {
  const context = useContext(PlansContext);
  if (!context) {
    throw new Error('usePlansContext must be used within a PlansProvider');
  }
  return context;
};

export const PlansProvider = ({ children }) => {
  const { list: listPlans, save, update, remove } = usePlans();
  
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPlans = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const plansData = await listPlans();
      
      const validPlans = Array.isArray(plansData)
        ? plansData.filter(p => p && p.id)
        : [];

      setPlans(validPlans);
    } catch (err) {
      console.error("Error fetching plans:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [listPlans]);

  // Load data on initial mount
  useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  const value = {
    plans,
    loading,
    error,
    fetchPlans,
    savePlan: save,
    updatePlan: update,
    removePlan: remove
  };

  return (
    <PlansContext.Provider value={value}>
      {children}
    </PlansContext.Provider>
  );
};

export default PlansContext;